var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.msg),expression:"msg"}],staticClass:"status-message-container"},[_c('div',{staticClass:"status-message"},[_vm._v("\n    "+_vm._s(_vm.msg)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }